module.exports = __webpack_public_path__ + "static/screenshot5-4df2b2d18dab6a47411aaebf32f1c06a.png";